module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/MEDICINE-a61ec9811873f57938fa38899483441b.png";